import { render, staticRenderFns } from "./select-status-salaries.vue?vue&type=template&id=deae3abc&"
import script from "./select-status-salaries.vue?vue&type=script&lang=js&"
export * from "./select-status-salaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports